module.exports = __webpack_public_path__ + "static/img/icon_play_dark_hover.6194634.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_play_dark_hover.svg
// module id = M5rd
// module chunks = 10